/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'

export type FormattedSurfaceProps = {
  value: number
}

function FormattedSurface (props: FormattedSurfaceProps) {
  const { value } = props
  const intl = useIntl()
  return value != null
    ? `${intl.formatNumber(value, { unit: 'meter', style: 'unit' })}²`
    : null
}

export default FormattedSurface
